import axios from 'axios';

const instance = axios.create({
    baseURL: 'http://localhost:5001/clone-d30f9/us-central1/api' //THE API (cloud function) URL
        //http://localhost:5001/clone-d30f9/us-central1/api
});

export default instance;

//https://us-central1-clone-d30f9.cloudfunctions.net/api
//